const truncateString = (text, desiredLength)=>text.length > desiredLength ? text.substring(0, desiredLength - 1) + '…' : text
;

export { truncateString as default, truncateString };
//# sourceMappingURL=truncate-string.js.map
